import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Title from '../../components/common/Title';
import Card from '../../components/elements/Card';
import Image from '../../components/images/Image';
import { fetchUserInfo, teamPhoto } from '../../utils';
import Back from '../../components/common/Back';
import Center from '../../components/css/Center';
import SameLine from '../../components/css/SameLine';
import ProgressBar from '../../components/elements/ProgressBar'; // assuming you have one
import { useTranslation } from 'react-i18next';
import NotFound from '../../components/common/NotFound';

const ReadinessPage = () => {
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserInfo('/company-readiness', setUserInfo, setLoading, setError);
  }, []);

  return (
    <Base activeNav="home">
      <Back to="/home" />
      <Title my="0" className="mt-4 mb-2">{t('yourReadinessChecklist')}</Title>

      {userInfo?.teams?.length > 0 ? (
        <>
          {userInfo.teams.map((team) => {
            const teamImg = teamPhoto(team.photo, team.company_picture);
            const containImg = !team.photo && !!team.company_picture;
            return (
            <Card
              key={team.team_id}
              to="/team"
              onClick={() => sessionStorage.setItem('otherTeamId', team.team_id)}
              mx="3"
              mb="2"

            >
              <SameLine className="row">
                {/* LEFT: Image */}
                <div className="col-4 d-flex align-items-center">
                  <Image
                    url={teamImg}
                    contain={containImg}
                    size="7rem"
                    className="me-2"
                  />
                </div>

                {/* RIGHT: Readiness */}
                <div className="col-8 d-flex flex-column justify-content-center text-center" style={{ marginLeft: '-0.8rem' }}>
                  <div style={{ fontSize: '1.2rem', fontWeight: '700' }}>
                    {t('readiness')}: {team.readiness}%
                  </div>

                  {/* Optional: progress bar visual */}
                  <ProgressBar value={team.readiness} height="8px" className="my-2" />

                  <div style={{ fontSize: '1rem', fontWeight: '600' }}>
                    {team.name}
                  </div>
                  
                </div>
              </SameLine>
            </Card>
            );
          })}
        </>
      ) : (
        <NotFound translationKey="noTeamFound" loading={loading} />
      )}
    </Base>
  );
};

export default ReadinessPage;
